const InclusiveLeadTimeType = Object.freeze({
  InStock: 'In Stock',
  StockRun: 'Stock Run',
  BuildToOrder: 'Build to Order',
});

export default InclusiveLeadTimeType;
